// extracted by mini-css-extract-plugin
var _1 = "RentalPortalApplicantsBoardColumnSkeleton-moduleRentalPortalApplicantsBoardColumnSkeleton__lPZSR";
var _2 = "RentalPortalApplicantsBoardColumnSkeleton-modulemeta__XvHXU Skeleton-moduleSkeleton__Mlrfv";
var _3 = "RentalPortalApplicantsBoardColumnSkeleton-moduletitle___lhDC Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "RentalPortalApplicantsBoardColumnSkeleton", _2 as "meta", _3 as "title" }
